module.exports = __webpack_public_path__ + "static/media/Plan.d0b6e668.jpg";